import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state.registrationState || initialState;

export const selectRegistrationDriverCabinFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.driverCabinFilter
);

export const selectRegistrationAxlesMeasureFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.axlesMeasureFilter
);

export const selectRegistrationFrontLoadFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.frontLoadFilter
);

export const selectRegistrationRearAxlesMeasureFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.rearAxlesMeasureFilter
);

export const selectRegistrationWeightFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.weightFilter
);

export const selectRegistrationTireFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.tireFilter
);

export const selectRegistrationDhTypeFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.dhTypeFilter
);

export const selectRegistrationBodyTypeFilter = createSelector(
  [selectDomain],
  (registrationState) => registrationState.bodyTypeFilter
);

export const selectRegistrationLoading = createSelector(
  [selectDomain],
  (registrationState) => registrationState.loading
);

export const selectRegistrationList = createSelector(
  [selectDomain],
  (registrationState) => registrationState.list
);

export const selectRegistrationMeta = createSelector(
  [selectDomain],
  (registrationState) => registrationState.meta
);

export const selectRegistrationPage = createSelector(
  [selectDomain],
  (registrationState) => registrationState.page
);

export const selectRegistrationPerPage = createSelector(
  [selectDomain],
  (registrationState) => registrationState.perPage
);

export const selectIsAddModalOpen = createSelector(
  [selectDomain],
  (registrationState) => registrationState.isAddModalOpen
);

export const selectRegistrationForm = createSelector(
  [selectDomain],
  (registrationState) => registrationState.form
);

export const selectRegistrationSaving = createSelector(
  [selectDomain],
  (registrationState) => registrationState.saving
);
